import HeaderSection from '../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../components/CockpitCards/CardTransparent';


export default function MethylomeText() {

    
    return (

<CardTransparent content = {
        
        <HeaderSection

            headline_p1 = "Keep asking:" 
            headline_grey = "What drives your aging?"
            headline_p2 = "Know your aging accelerators."

            text1 = "The good news: aging is a risk factor, but one that you  can and should influence significantly!"
            text2 = "In this section you find a detailed analysis what drives your personal aging and what you can do to slow it down."

        />
    }/>
            
  )
}